import { NgForOf } from '@angular/common';
import { Input, Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { PreviewRoute } from '../../utils/get-preview-paths';

@Component({
  selector: 'email-preview-nav',
  template: `<div class="mode">
      <a
        [routerLink]="active?.interpolatedUrl"
        [routerLinkActive]="'active'"
        (click)="$event.stopPropagation()"
        >Preview</a
      >
      |
      <a
        [routerLink]="active?.mailgunUrl"
        [routerLinkActive]="'active'"
        (click)="$event.stopPropagation()"
        >Mailgun</a
      >
    </div>
    <ul data-theme="light">
      <li
        *ngFor="let route of routes; trackBy: trackByRoute"
        [routerLink]="route.interpolatedUrl"
        [class.active]="active === route"
      >
        {{ route.name }}
      </li>
    </ul>`,
  styleUrls: ['./email-preview-nav.component.less'],
  imports: [NgForOf, RouterLink, RouterLinkActive],
  standalone: true,
})
export class EmailPreviewNavComponent {
  public router = inject(Router);

  @Input() public routes: PreviewRoute[];
  @Input() public active?: PreviewRoute;

  public trackByRoute(index: number, route: PreviewRoute): string {
    return route.mailgunUrl;
  }
}
